import { InvoiceResource } from '@/types/resources';
import { InvoiceStatus, PaymentMethod } from '@/utils/enums';

// Whether an invoice can be ticked for export/status changes. Shared by the
// row checkbox and the select-all header so both apply the same rules: unpaid
// invoices need complete receiver/bank details, and on the unpaid tabs they
// must also be approved.
export const isInvoiceSelectable = (
  invoice: InvoiceResource,
  requiresApproval: boolean,
) => {
  // PayPal and Payoneer invoices are settled by email, so bank-detail checks
  // don't apply to either.
  const isWalletInvoice = invoice.payment_method !== PaymentMethod.Bank;

  const hasDetails =
    isWalletInvoice ||
    (!!invoice.member.name &&
      !!invoice.bank.bank &&
      !!invoice.bank.iban &&
      !!invoice.bank.swift_code);

  return (
    (invoice.status === InvoiceStatus.Paid || hasDetails) &&
    (!requiresApproval || !!invoice.approved_at)
  );
};
